import { LocaleService } from '@daisi/services/locale/locale.service';

export function initDaisiApp(localeService: LocaleService): () => Promise<void> {
  localeService.setLocale('nl');
  return () => Promise.resolve();
}
